import App from '@modules/husleie-framework/src/static-classes/App.class.js';
import type {
  LandlordAPIInterface,
  LandlordCreate,
  LandlordCreateResponse,
  LandlordGet,
  LandlordGetResponse,
  LandlordProfileAddressGet,
  LandlordProfileAddressGetResponse,
  LandlordProfileUpdate,
  LandlordRentalObjectsGet,
  LandlordRentalObjectsGetResponse,
  LandlordContractsGet,
  LandlordContractsGetResponse,
  LandlordContractDelete,
  LandlordContractDeleteResponse,
  LandlordInspectionReportsGet,
  LandlordInspectionReportsGetResponse,
  LandlordInspectionReportDelete,
  LandlordInspectionReportDeleteResponse,
  LandlordDownloadTokenGet,
  LandlordDownloadTokenGetResponse,
  LandlordDownloadSessionGet,
  LandlordDownloadSessionGetResponse,
  LandlordTenanciesGet,
  LandlordTenanciesGetResponse,
  LandlordTenancySubscriptionsGetResponse,
  LandlordTenancySubscriptionsUpdate,
  LandlordTenancyGetResponse,
  LandlordTenancyGet,
  LandlordTenancyDocumentsGet,
  LandlordTenancyDocumentsGetResponse,
} from '@modules/store/landlord/types/LandlordAPI.interface';
import { LandlordTenancySubscriptionsGet } from '@modules/store/landlord/types/LandlordAPI.interface';
import APIMocked from './index.mock-api';
import APIReal from './index.real-api';

export default class API implements LandlordAPIInterface {
  private readonly api: any;

  constructor() {
    this.api = App.isMockedAPI() ? new APIMocked() : new APIReal();
  }

  createLandlord(create: LandlordCreate): Promise<LandlordCreateResponse> {
    return this.api.createLandlord(create);
  }

  getLandlord(get: LandlordGet): Promise<LandlordGetResponse> {
    return this.api.getLandlord(get);
  }

  getProfileLandlordPostalAddress(get: LandlordProfileAddressGet): Promise<LandlordProfileAddressGetResponse> {
    return this.api.getProfileLandlordPostalAddress(get);
  }

  patchProfileLandlord(update: LandlordProfileUpdate): Promise<void> {
    return this.api.patchProfileLandlord(update);
  }

  getLandlordRentalObjects(get: LandlordRentalObjectsGet): Promise<LandlordRentalObjectsGetResponse> {
    return this.api.getLandlordRentalObjects(get);
  }

  getLandlordContracts(get: LandlordContractsGet): Promise<LandlordContractsGetResponse> {
    return this.api.getLandlordContracts(get);
  }

  getLandlordTenancy(get: LandlordTenancyGet): Promise<LandlordTenancyGetResponse> {
    return this.api.getLandlordTenancy(get);
  }

  getLandlordTenancies(get: LandlordTenanciesGet): Promise<LandlordTenanciesGetResponse> {
    return this.api.getLandlordTenancies(get);
  }

  getLandlordTenancySubscriptions(
    get: LandlordTenancySubscriptionsGet
  ): Promise<LandlordTenancySubscriptionsGetResponse> {
    return this.api.getLandlordTenancySubscriptions(get);
  }

  updateLandlordTenancySubscription(update: LandlordTenancySubscriptionsUpdate): Promise<void> {
    return this.api.updateLandlordTenancySubscription(update);
  }

  getLandlordInspectionReports(get: LandlordInspectionReportsGet): Promise<LandlordInspectionReportsGetResponse> {
    return this.api.getLandlordInspectionReports(get);
  }

  deleteLandlordContract(remove: LandlordContractDelete): Promise<LandlordContractDeleteResponse> {
    return this.api.deleteLandlordContract(remove);
  }

  deleteLandlordInspectionReport(
    remove: LandlordInspectionReportDelete
  ): Promise<LandlordInspectionReportDeleteResponse> {
    return this.api.deleteLandlordInspectionReport(remove);
  }

  getLandlordDownLoadToken(get: LandlordDownloadTokenGet): Promise<LandlordDownloadTokenGetResponse> {
    return this.api.getLandlordDownLoadToken(get);
  }

  getLandlordDownLoadSession(get: LandlordDownloadSessionGet): Promise<LandlordDownloadSessionGetResponse> {
    return this.api.getLandlordDownLoadSession(get);
  }

  getLandlordTenancyDocuments(get: LandlordTenancyDocumentsGet): Promise<LandlordTenancyDocumentsGetResponse> {
    return this.api.getLandlordTenancyDocuments(get);
  }
}
